import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text as ChakraText,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { colors } from '../../../ui-kit'

interface OriginDeleteModalProps {
  isOpenDeleteOrigin: boolean
  originName: string
  onSubmit(): Promise<void>
  onCloseDeleteOrigin(): void
}

export const OriginDeleteModal = ({
  isOpenDeleteOrigin,
  onCloseDeleteOrigin,
  onSubmit,
  originName,
}: OriginDeleteModalProps): React.ReactElement => {
  const [isDeleteDisabled, setIsDeleteDisabled] = useState(false)
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpenDeleteOrigin} onClose={onCloseDeleteOrigin} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('delete_origin', 'Delete Origin')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Trans t={t} i18nKey="delete_origin_modal_description">
            <ChakraText color={colors.appBattleshipGrey}>
              Origin {{ originName }} will be permanently deleted. Click on
              submit to proceed with the operation.
            </ChakraText>
          </Trans>
        </ModalBody>
        <ModalFooter borderTop="1px solid #e7eaf0" style={{ gap: '1em' }}>
          <Button
            onClick={onCloseDeleteOrigin}
            variant="outline"
            isDisabled={isDeleteDisabled}
          >
            {t('cancel', 'Cancel')}
          </Button>
          <Button
            type="submit"
            colorScheme="appRed"
            isDisabled={isDeleteDisabled}
            onClick={async () => {
              setIsDeleteDisabled(true)
              await onSubmit()
              setIsDeleteDisabled(false)
              onCloseDeleteOrigin()
            }}
          >
            {t('submit', 'Submit')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
